import cls from "classnames";
import React from "react";
import { ImageUpload } from "../../image-upload/image-upload.js";
import { TextField } from "../../text-field/text-field.js";
import { PollOptionBase } from "../poll-option-base.js";
import styles from "./option-webview-scss.js";
class PollGridOptionWebview extends PollOptionBase {
  render() {
    const { option, dark, t } = this.props;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles.option, styles.grid, {
          [styles.with_image]: this.isImageEnabled(),
          [styles.dark]: dark
        })
      },
      this.isImageEnabled() && /* @__PURE__ */ React.createElement(ImageUpload, { className: styles.image, value: option.image.src.url }),
      /* @__PURE__ */ React.createElement("div", { className: styles.title }, /* @__PURE__ */ React.createElement(
        TextField,
        {
          maxLength: 60,
          className: cls(styles.input),
          value: option.title,
          placeholder: t("Poll_Editor_Answer_Placeholder")
        }
      ))
    );
  }
}
PollGridOptionWebview.propTypes = PollOptionBase.propTypes;
export {
  PollGridOptionWebview
};
//# sourceMappingURL=poll-grid-option-webview.js.map
